import { useContext, useEffect } from 'react';
import { NavbarModuleItem } from '../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';
import { RouteItem } from '../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { NavbarContext } from '../utils/Navbar';
import { PermissionsContext } from '../utils/Permissions';
import { RouterContext } from '../utils/Router';
import { TabPermissionItem } from './BackUsers/Pages/components/PermissionsTreeContainer/PermissionsTreeContainer';

export type ModuleKey =
    | 'AuthModule'
    | 'BackUsersModule'
    | 'TeamsModule'
    | 'ClustersModule'
    | 'AreasModuleV1'
    | 'AreasModule'
    | 'SectorsModule'
    | 'ShopsModule'
    | 'FrontUsersModule'
    | 'StatsModule'
    | 'NewsModule'
    | 'OffersModule'
    | 'EventsModule'
    | 'SurveysModule'
    | 'VideosModule'
    | 'QuizzesModule'
    | 'ChallengesModule'
    | 'CollectionsModule'
    | 'AuditsModule'
    | 'IndicatorsModule'
    | 'ContactsModule'
    | 'RolesModule'
    | 'TagsModule'
    | 'PinCodesModule'
    | string;

export type ModuleProps = {
    moduleKey: ModuleKey;
    routes: RouteItem[];
    navBarItems?: NavbarModuleItem[];
    permissionsItems?: TabPermissionItem[];
};

export const Module = ({ routes, moduleKey, navBarItems, permissionsItems }: ModuleProps) => {
    const routerContext = useContext(RouterContext);
    useEffect(() => {
        routerContext.register(moduleKey, routes);
        return () => routerContext.unregister(moduleKey);
    }, []);

    const navbarContext = useContext(NavbarContext);
    useEffect(() => {
        if (!navBarItems) {
            return;
        }
        navbarContext.register(moduleKey, navBarItems);
        return () => navbarContext.unregister(moduleKey);
    }, []);

    const permissionContext = useContext(PermissionsContext);
    useEffect(() => {
        if (!permissionsItems) {
            return;
        }
        permissionContext.register(moduleKey, permissionsItems);
        return () => permissionContext.unregister(moduleKey);
    }, []);

    return null;
};
